/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetDownloadIcon16Light = forwardRef('NetDownloadIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.5 1a.5.5 0 0 1 .5.5v8.373c.056-.032.109-.07.159-.114l3.012-2.635a.5.5 0 1 1 .658.752l-3.012 2.636a2 2 0 0 1-2.634 0L3.171 7.876a.5.5 0 1 1 .658-.752l3.013 2.635c.05.044.102.082.158.114V1.5a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M1 13.5a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 0 1h-12a.5.5 0 0 1-.5-.5Z" })));
});
